import { validateEmail } from 'utils/helpers';
import isConsentGranted from 'utils/consent-check';
import { getTechnicalData } from '../utils/storefront/format-resource';

const AttentiveEmailSignUp = async (analyticsEvent, consentRequired) => {
  const emailFormWrapper = document.querySelector('[data-newsletter-form]');
  const emailForm = emailFormWrapper.querySelector('form');
  const emailInputWrapper = emailFormWrapper.querySelector('domaine-input[data-input]');
  const emailFormInput = emailFormWrapper.querySelector('input[type="email"]');
  const checkBoxInputWrapper = emailFormWrapper.querySelector('domaine-input[data-checkbox]');
  const checkBoxInput = emailFormWrapper.querySelector('input[type=checkbox]');
  emailInputWrapper.removeAttribute('error');
  checkBoxInputWrapper.removeAttribute('error');

  try {
    if (
      emailFormInput.value.trim().length === 0 ||
      validateEmail(emailFormInput.value) === false ||
      !isConsentGranted(consentRequired) ||
      (checkBoxInput && !checkBoxInput.checked)
    ) {
      if (!isConsentGranted(consentRequired)) {
        emailInputWrapper.errorText = window.TMW.Strings.general.forms.submitError.consent;
        throw new Error(window.TMW.Strings.general.forms.submitError.consent);
      }
      if (checkBoxInput && !checkBoxInput.checked) {
        emailInputWrapper.errorText = window.TMW.Strings.general.forms.submitError.optInRequired;
        checkBoxInputWrapper.setAttribute('error', '');
        throw new Error(window.TMW.Strings.general.forms.submitError.optInRequired);
      }
      emailInputWrapper.errorText = window.TMW.Strings.general.forms.submitError.email;
      throw new Error(window.TMW.Strings.general.forms.submitError.email);
    }

    const emailValue = emailFormInput.value;
    const SourceId = getTechnicalData('attentiveEmailSource');
    const apiUrl = getTechnicalData('attentiveSMSAPI');
    const apiId = getTechnicalData('yotpoSMSkey');
    const apiPassword = getTechnicalData('yotpoSMSsecret');

    const payload = {
      email: emailValue,
      signUpSourceId: SourceId,
    };

    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Basic ${btoa(`${apiId}:${apiPassword}`)}`,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error('Failed to submit email to Attentive API via Unifi');
    }

    emailFormWrapper.setAttribute('success', '');

    if (analyticsEvent) {
      const formData = new FormData(emailForm);
      const data = Object.fromEntries(formData);
      Shopify.analytics.publish(analyticsEvent, data);
    }

    emailFormInput.value = '';
    setTimeout(() => {
      emailFormWrapper.removeAttribute('success');
    }, 5000);
  } catch (error) {
    emailInputWrapper.setAttribute('error', '');
  }
};

export default AttentiveEmailSignUp;
